import * as restfulService from '../../../services/restfulService'

export const buscarAvaliacaoPeloHash = (hash) => {
  return new Promise((resolve, reject) => {
    restfulService.get('avaliacao/' + hash)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const salvarRedacao = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('avaliacao/salvar-redacao', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}

export const finalizarRedacao = (data) => {
  return new Promise((resolve, reject) => {
    restfulService.post('avaliacao/salvar-redacao', null, null, data)
      .then((response) => {
        resolve(response)
      })
      .catch(e => {
        reject(e)
      })
  })
}



// WEBPACK FOOTER //
// ./src/app/domains/avaliacao/services/avaliacaoService.js